import { OverlayContainer } from '@angular/cdk/overlay';
import { Component, inject, Renderer2 } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { ThemeStore } from '@shared/stores/theme.store';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: 'app.html',
})
export class AppComponent {
  title = 'AprendeSSO-Front';
  // injects
  private _themeStore = inject(ThemeStore);
  private _overlayContainer = inject(OverlayContainer);
  private _renderer = inject(Renderer2);

  constructor() {
    this._themeStore.init();
    toObservable(this._themeStore.isDarkMode)
      .pipe(takeUntilDestroyed())
      .subscribe({
        next: (isDarkMode) => this._updateThemeClasses(isDarkMode),
      });
  }

  private _updateThemeClasses(isDarkMode: boolean) {
    const overlayContainerElement = this._overlayContainer.getContainerElement();

    this._renderer[isDarkMode ? 'addClass' : 'removeClass'](document.documentElement, 'dark');
    this._renderer[isDarkMode ? 'addClass' : 'removeClass'](overlayContainerElement, 'dark');
  }
}
